export const generateId = () => '_' + Math.random().toString(36).substr(2, 9)
export const delay = (ms = 1000) => new Promise(resolve => setTimeout(resolve, ms))
export const randomBetween = (from, to) => Math.floor(Math.random() * to) + from


// WEBPACK FOOTER //
// ./util/pseudoApi.js